import debounce from 'lodash-es/debounce';

let payload = {};

function partnerFormPostMessageListener(event, formValues, reinitializeForm) {
  let { data } = event;
  try {
    data = typeof event.data === 'string' && JSON.parse(event.data);
  } catch (e) {
    // no-op
  }

  if (!data || (!data.loan && !data.applicant)) return;

  payload = {
    ...payload,
    loan: {
      ...payload.loan,
      ...data.loan,
    },
    applicant: {
      ...payload.applicant,
      ...data.applicant,
    },
  };

  debounce(() => {
    reinitializeForm('application', {
      expanded: true,
      ...formValues,
      ...payload.loan,
      applicant: {
        ...formValues.applicant,
        ...payload.applicant,
      },
    });
  }, 100)();
}

export default partnerFormPostMessageListener;
